import { useState } from 'react';
// import { Link } from 'react-router-dom';
import Slider, { Settings } from 'react-slick';
import ImageContainer from '../../components/ui/ImageContainer';
// import ImageContainer from '../../components/ui/ImageContainer';
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { IHeroVideos } from '../../types';
import { HeroVideos, HeroVideosBn } from '../../utils';
import './styles.css';

function Home() {
  const locale = getData(LANGUAGE);
  const data = locale === 'en' ? HeroVideos : HeroVideosBn
  const [, setIsPrevShow] = useState(false);
  const settings: Settings = {
    // dots: true,
    // infinite: true,
    // speed: 500,
    // autoplaySpeed: 5000,
    // autoplay: true,
    // slidesToShow: 1,
    // slidesToScroll: 1,
    // initialSlide: 1,
    // arrows: false,
    dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    dotsClass: 'button__bar',
    beforeChange: (next: any) => {
      if (next > 0) {
        setIsPrevShow(true);
      } else {
        setIsPrevShow(false);
      }
    },
  };

  return (
    <div className="w-full lg:flex lg:space-x-10">
      

      <Slider {...settings} className="z-30 w-full">
        {data.map((item: IHeroVideos, key: number): any => {
          return (
            <div key={key} className="relative ">
              {' '}
              {/* <video
                id="vid"
                playsInline
                autoPlay
                muted
                loop
                className="flex items-center justify-center w-full border"
                // style={{ height: '800px' }}
                // controls
              >
                <source src={item.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
              <ImageContainer src={item.video} alt={item.video} className="h-100vh flex items-center justify-center w-100vw border border-none" />
              
              
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default Home;
